import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle as faInfoCircleSolid } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faInfoCircle as faInfoCircleLight } from '@fortawesome/pro-light-svg-icons/faInfoCircle';

import academicNeedImg from '../../../../assets/academia/group-20.svg';
import {
  studentResearchesInfo,
  academicNeedsHeadItems,
  classRoom,
} from '../../../../data/landinaPages/academiaLanding';
import { scrollToForm } from '../../../../helpers/landingPagesHelpers';
import withComponentName from '../../../../decorators/withComponentName';

import Styles from '../styles.module.scss';
import ButtonComponent from '../../../Buttons/ButtonComponent';
import Tooltip from '../../../Tooltip';

const AcademicNeedsSection = () => (
  <section className={Styles['academic-needs-section']}>
    <div className={Styles['section-wrapper']}>
      <div className={Styles['section-head']}>
        <h2 className={Styles['section-title']}>For All Your Academic Needs</h2>
      </div>
      <ul className={Styles['academic-needs-head-list']}>
        {academicNeedsHeadItems.map(({ id, icon, text }) => (
          <li key={id}>
            <FontAwesomeIcon icon={icon} />
            <p className={Styles.description}>{text}</p>
          </li>
        ))}
      </ul>
      <div className={Styles['academic-needs-bottom']}>
        <div className={Styles['academic-needs-lists']}>
          <div className={Styles['academic-list-wrapper']}>
            <h3>Students and Researchers</h3>
            <AcademicNeedsListItem
              list={studentResearchesInfo}
            />
          </div>
          <div className={Styles['academic-list-wrapper']}>
            <h3>In the Classroom</h3>
            <AcademicNeedsListItem
              list={classRoom}
            />
          </div>
          <ButtonComponent
            value="Contact Us"
            path=""
            clickHandler={scrollToForm}
            green
          />
        </div>
        <div className={Styles['academic-needs-image']}>
          <img src={academicNeedImg} alt="" />
        </div>
      </div>
    </div>
  </section>
);

const AcademicNeedsListItem = ({ list }) => (
  <ul className={Styles['academic-list']}>
    {list.map(({ id, text, tooltip }) => (
      <li key={id}>
        <span>
          0
          {id}
        </span>
        <p>{text}</p>
        {tooltip && (
          <Tooltip
            className="tooltip-plan-suggestion"
            icon={(
              <div className={Styles['tooltip-icon']}>
                <FontAwesomeIcon icon={faInfoCircleSolid} />
                <FontAwesomeIcon icon={faInfoCircleLight} />
              </div>
            )}
          >
            Not all content from
            <br />
            <a href="https://help.cityfalcon.com/hc/en-us/articles/360034657073-Premium-Publications-and-Content" target="_blank" rel="noopener noreferrer">
              Premium publications
            </a>
            {' '}
            is
            <br />
            paywall-free
          </Tooltip>
        )}
      </li>
    ))}
  </ul>
);

export default withComponentName(AcademicNeedsSection);
